/**
 * Safely parses a component's `data` JSON blob (catalog `componentsv2` payload).
 * Returns the parsed object, or `null` if `data` is missing, non-string, or malformed JSON.
 */
export const parseComponentData = (data: unknown): Record<string, any> | null => {
  if (typeof data !== 'string' || data.length === 0) return null
  try {
    const parsed = JSON.parse(data)
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, any>) : null
  } catch {
    return null
  }
}

/**
 * Returns the catalog `title` stored on a component's `data` JSON, or `undefined` when unavailable.
 * Used as a display-name fallback for "other" type components when supplier descriptions are empty.
 */
export const getComponentTitleFromData = (data: unknown): string | undefined => {
  const parsed = parseComponentData(data)
  const title = parsed?.title
  return typeof title === 'string' && title.length > 0 ? title : undefined
}

export const getComponentTypeV2 = (componentData: { [key: string]: any }) => {
  if (componentData?.data) {
    const parentComponentData = parseComponentData(componentData.data)
    return parentComponentData && parentComponentData.other_component_type !== componentData?.other_component_type
      ? parentComponentData.other_component_type
      : componentData?.other_component_type
  }
  return componentData?.other_component_type
}
